import { render, staticRenderFns } from "./MenuKanban.vue?vue&type=template&id=33433db4&"
import script from "./MenuKanban.vue?vue&type=script&lang=js&"
export * from "./MenuKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports